



















import Vue from 'vue'
export default Vue.extend({
  props: [
    'data',
  ],
  computed: {
    jsonContent(): string {
      return JSON.stringify(this.data, null, 2).trim();
    }
  }
})
